import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CrListItemComponent } from '../cr-list-item/cr-list-item.component';
import { CrActiviteInterneItemComponent } from '../cr-activite-interne-item/cr-activite-interne-item.component';
import { NgIf } from '@angular/common';
import { ChronoInput } from '../../../shared/models/chrono.model';
import { CrActiviteInterne } from '../../../shared/models/activite-interne/activite-interne.model';
import { CrView } from '../../../shared/models/v2/cr.model';
import { PostCrRequest, PostCrResponse } from '../../../shared/models/v2/post-cr.model';

@Component({
  selector: 'cr-list-vue-jour',
  templateUrl: 'cr-list-vue-jour.component.html',
  standalone: true,
  styleUrls: ['./cr-list-vue-jour.component.scss'],
  imports: [IonicModule, CrListItemComponent, CrActiviteInterneItemComponent, NgIf],
})
export class CrListVueJourComponent {
  /**
   * Booléen vérifiant si le mode suppression des brouillons est actif
   */
  @Input() isDraftCrDeletionModeActive: boolean;

  /**
   * Liste des CR filtrés
   */
  @Input() crListUserFiltered: (CrView | ChronoInput | CrActiviteInterne | PostCrResponse)[];

  /**
   * Liste des CR en cours d'envoi (utilisé pour le mode offline)
   */
  @Input() crEnCoursDenvoiFiltered: PostCrRequest[];

  @Output() crEmitter = new EventEmitter<PostCrResponse | CrView | PostCrRequest | ChronoInput>();

  @Output() crActiviteInterneEmitter = new EventEmitter<CrActiviteInterne>();

  constructor() {}

  /**
   * Emet le CR vers le composant parent afin d'ouvrir le détail du CR
   */
  goToCrDetails(cr) {
    this.crEmitter.emit(cr);
  }

  /**
   * Emet le CR de l'activité interne vers le composant parent afin d'ouvrir le détail du CR
   */
  goToCrActiviteInterneDetails(crActiviteInterne: CrActiviteInterne) {
    this.crActiviteInterneEmitter.emit(crActiviteInterne);
  }
}
